import { DialogHeader, DialogTitle, DialogDescription } from '@/components/ui';
import { useFormContext, useWatch } from 'react-hook-form';
import { TFormData } from '.';

const FormCreateAccountingUserHeader = () => {

    const { control } = useFormContext<TFormData>();
    const _id = useWatch({ control, name: '_id' });
    const readonly = useWatch({ control, name: 'readonly' });

    const title = (
        readonly
            ? 'Détails de l\'utilisateur'
            : _id
                ? 'Modifier l\'utilisateur'
                : 'Créer un utilisateur comptable'
    );

    const description = (
        readonly
            ? 'Informations de l\'utilisateur comptable'
            : 'Remplissez les informations pour créer un utilisateur de type employé ou investisseur'
    );

    return (
        <DialogHeader className="space-y-1 md:space-y-1.5">
            <DialogTitle className="text-lg md:text-xl">
                {title}
            </DialogTitle>
            <DialogDescription className="text-xs md:text-sm">
                {description}
            </DialogDescription>
        </DialogHeader>
    );

};

export default FormCreateAccountingUserHeader;
